import "../styles/index.scss"

console.info("Bridgetown is loaded!")
